import type { ScreenSchema } from './types';
const textareaSchema: ScreenSchema = {
  template: 'textarea',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' },
        { field: 'question' }
      ]
    }
  }
};
export default textareaSchema;
